import React from 'react';
import classnames from 'classnames';
import Check from './check.svg.js';
import Error from './error.svg.js';
import styles from './styles.css.js';

var Notification = function Notification(_a) {
  var _b = _a.type,
      type = _b === void 0 ? 'info' : _b,
      children = _a.children,
      hideIcon = _a.hideIcon,
      className = _a.className;
  var classes = classnames(styles[type], className);
  var Glyph = Check;

  if (type === 'error') {
    Glyph = Error;
  }

  return React.createElement("div", {
    className: classes
  }, React.createElement("div", {
    className: styles.padding
  }, !hideIcon && React.createElement(Glyph, {
    className: styles.icon
  }), React.createElement("span", {
    className: styles.label
  }, children)));
};

export default Notification;
//# sourceMappingURL=index.js.map
